// This file was automatically generated from tourguide.chartInfoSplash.html.
// Please don't edit this file by hand.

goog.provide('el8.template.tourguide.chartInfoSplash');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.tourguide.homeInfoSplash');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.chartInfoSplash.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="info-splash-content"><div class="splashCloseTrigger close-trigger"></div><div class="SplashHeading">Patient Chart</div><div class="SplashSubheading">click each section title to learn more</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.chartInfoSplash.patientProfileBlock = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="SplashBlockContentsProfile"><p class="SplashBlockHeading Profile"><a class="el8LightLink" target="_blank" rel="noopener" href="https://help.elationhealth.com/s/article/clinical-profile-record-patient-medical-history">CLINICAL PROFILE</a></p><p class="SplashBlockText">Quickly and easily reference key patient information.</p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.chartInfoSplash.writeSeeBarBlock = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="SplashBlockContentsShortcut"><p class="SplashBlockHeading Shortcut"><a class="el8LightLink" target="_blank" rel="noopener" href="https://help.elationhealth.com/s/article/Patient-Chart-Navigation-Bar">Navigate the Patient Chart</a></p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.chartInfoSplash.chartFeedBlock = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="SplashBlockContentsRight"><div class="SplashBlockRightSection"><p class="SplashBlockHeading Search">CHART SEARCH</p><p class="SplashBlockText">Search for anything in the chronological record and find it immediately.</p></div><div class="SplashBlockRightSection"><p class="SplashBlockHeading Record"><a class="el8LightLink" target="_blank" rel="noopener" href="https://help.elationhealth.com/s/article/store-everything-in-chronological-record">CHRONOLOGICAL RECORD</a></p><p class="SplashBlockText">A chronology of all information in the patient\'s medical history, including prescriptions, lab results, visit notes, and messages.</p></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.chartInfoSplash.infoSplashBlock = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.tourguide.homeInfoSplash.infoSplashBlock(null, output);
  if (!opt_sb) return output.toString();
};
